import Loader from "@/components/Loader/Loader";
import routes from "@/routes/routes";
import { memo, Suspense, useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import styles from "./PreLogin.module.scss";

const PreLogin = () => {
  const images = [
    "/login-page-slider1.jpg",
    "/login-page-slider2.jpg",
    "/login-page-slider3.jpg",
  ];
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const location = useLocation();

  return (
    <div className={styles.mainContainer}>
      <div
        className={styles.main_img}
        style={{ backgroundImage: `url(${images[current]})` }}
      >
        <div className={styles.main_img_content}>
          <div className={styles.headingDiv}>
            <h2 className={styles.heading}>
              Daily Employee attendance tracking
            </h2>
            <p className={styles.subHeading}>
              Application allows you to monitor your employee’s Check-In,
              Check-Out time and attendance from anywhere and at any time
            </p>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loader />}>
        {location.pathname === "/auth/login" && (
          <span className={styles.topHeading}>
            <div className="m-5 text-lg">
              Don’t have an account yet? &nbsp;
              <Link
                to="/auth/register" className="text-blue-600 hover:underline"
              >
                Sign up
              </Link>
            </div>
          </span>
        )}
        <span className={styles.childrenContainer}>
          <Outlet />
        </span>
      </Suspense>
    </div>
  );
};

export default memo(PreLogin);
